import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import c from '../colors';
import { graphDataStyle, graphWallFill } from './';
import { increaseLumaDelta, interpolate } from '../util';

export const graphKPIRange = {
  range1: (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
    const color = c.colorKPI1(theme);
    return deriveKPIRange(theme, parameters, color, 'R3');
  },
  range2: (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
    const color = interpolate(c.colorKPI1(theme), c.colorKPI3(theme), 50);
    return deriveKPIRange(theme, parameters, color, 'L1');
  },
  range3: (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
    const color = c.colorKPI3(theme);
    return deriveKPIRange(theme, parameters, color, 'R4');
  },
  range4: (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
    const color = interpolate(c.colorKPI3(theme), c.colorKPI5(theme), 50);
    return deriveKPIRange(theme, parameters, color, 'X1');
  },
  range5: (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
    const color = c.colorKPI5(theme);
    return deriveKPIRange(theme, parameters, color, 'X3');
  },
};

const deriveKPIRange = (
  theme: ThemeParameters,
  parameters: RuntimeThemeParameters,
  color: string,
  fillPattern: string
) => {
  const graphDataStyleDefault = graphDataStyle.styleDefault(theme, parameters);
  const common = {
    color,
    fillColor: color,
    fillPattern,
    lineStyle: graphDataStyleDefault.lineStyle,
    lineThickness: graphDataStyleDefault.lineThickness,
    markerSize: graphDataStyleDefault.markerSize,
    markerSymbol: graphDataStyleDefault.markerSymbol,
  };
  switch (theme.baseThemeName) {
    case 'dark': {
      const altColor = increaseLumaDelta(color, graphWallFill(theme, parameters).fillColor, 32);

      return {
        ...common,
        altColor,
        lineColor: altColor,
        markerColor: altColor,
        textColor: altColor,
      };
    }
    case 'high-contrast': {
      const altColor = increaseLumaDelta(
        color,
        graphWallFill(theme, parameters).fillColor,
        12,
        true
      );

      return {
        ...common,
        altColor,
        lineColor: altColor,
        markerColor: altColor,
        textColor: altColor,
      };
    }
    default: {
      const altColor = increaseLumaDelta(color, graphWallFill(theme, parameters).fillColor, 22);

      return {
        ...common,
        altColor,
        lineColor: altColor,
        markerColor: altColor,
        textColor: increaseLumaDelta(color, graphWallFill(theme, parameters).fillColor, 32),
      };
    }
  }
};
